import { SET_PROCESS_MANAGER_ERROR_CLIENT_CLOSED_TEXT, SET_TEXTS } from './constants'

export function setProcessManagerErrorText(text) {
    return {
        type: SET_PROCESS_MANAGER_ERROR_CLIENT_CLOSED_TEXT,
        payload: text,
    }
}

export function setTexts(texts) {
    return {
        type: SET_TEXTS,
        payload: texts,
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/texts/actions.js